module.exports = __webpack_public_path__ + "static/media/login-bg-2.1a4780a3.jpg";